// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"122":"6fdc484f","127":"057dc49c","224":"7bc1de14","648":"fb68d15a","741":"71a6d105","853":"044db284"}[chunkId] + ".css";
};